import { useEffect, useRef } from "react";

const useStickyTimecontrol = (stuckClass = "is-stuck") => {
  const ref = useRef<any>(null);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        ref.current?.classList.toggle(stuckClass, entry.intersectionRatio < 1);
      },
      { threshold: 1 }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref, stuckClass]);

  return ref;
};

export default useStickyTimecontrol;
